<template lang="pug">
div
  .filter.my-2.py-2
    form.columns(@submit.prevent="listar")
      .column
        .form-group
          input.form-input.input-sm(
            v-model="q.titulo_cont",
            :placeholder="'mensagem.titulo' | tModel"
          )
      .column.col-auto
        button.btn.btn-sm.btn-primary.s-circle.tooltip.tooltip-left(
          data-tooltip="Filtrar"
        )
          i.icon.icon-search
  .divider
  load-manager(:status="status")
    list-manager(v-if="!loading" :status='status', :count='list.length')
      table.table.table-hover
        tbody
          tr.c-hand(v-for="mensagem in list" @click="show(mensagem)")
            td(width="1")
              i.fa.fa-paper-plane.fa-lg
            td
              .text-large {{ mensagem.titulo }}
              .text-gray(v-if="mensagem.assunto") {{ mensagem.assunto ? mensagem.assunto.descricao : '-' }}
              div(v-if='mensagem.destinatario')
                small.abbr Para:
                span.text-gray  {{ mensagem.destinatario.razao_social }}
            td.text-right
              small {{ mensagem.enviado_em | date }}
</template>

<script>
import listMixin, { vuexDefaultMapping } from '../mixins/list'
import parseErrors from '@/lib/errors/parseErrors'
import { deepClone } from 'paliari-js-utils'

export default {
  vuex: {
    'mensagens/enviadas': vuexDefaultMapping,
  },
  mixins: [listMixin],
  data() {
    return { q: { arquivada_remetente_eq: true } }
  },
  methods: {
    async listar() {
      try {
        this.setQuery(deepClone(this.q))
        await this.fetchList()
      } catch (e) {
        this.addErrors(parseErrors(e))
      }
    },
    show(mensagem) {
      this.$router.push({
        name: 'mensagensEnviadasShow',
        params: { id: mensagem.id },
      })
    },
  },
  async created() {
    this.listar()
  },
}
</script>
